import firebase from "firebase";
var config = {
  apiKey: "AIzaSyAwWpI1wXj7IB8whdMC1ubvL3Mg27KhvPI",
  authDomain: "shorted-6f98d.firebaseapp.com",
  databaseURL: "https://shorted-6f98d.firebaseio.com",
  projectId: "shorted-6f98d",
  storageBucket: "shorted-6f98d.appspot.com",
  messagingSenderId: "851439061625",
};
try {
  firebase.initializeApp(config);
} catch (err) {
  // we skip the "already exists" message which is
  // not an actual error when we're hot-reloading
  if (!/already exists/.test(err.message)) {
    console.error("Firebase initialization error", err.stack);
  }
}
// Initialize Cloud Firestore through Firebase
var db = firebase.firestore();
var auth = firebase.auth();
// Disable deprecated features

export { db, auth };
